import React from 'react';
import '../../../../../../styles/comments.css'
const Comments = ({visible = false, comments = '', handleChange = () => {}, handleSave = () => {}, isDisabled, title = '', type = ''}) => {
    return (
        <div className= {type ? 'main-comment-picture' : 'main-comment'}>
            { visible && 
            <div className="block-comment">
                <span className="text-md--white">{title || ''}</span>
                <textarea style={{resize: 'none'}} value={comments} rows={3} maxLength={500} onChange={(e) => handleChange(e.target.value)}/>
                <button type="button" className="btn btn-primary btn-sm w50p" disabled={isDisabled} onClick={handleSave}>Guardar</button>
            </div>}
        </div>

    )
}

export default Comments;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/damages/comments.js